import Dexie from "dexie";

// Cache de instancias de Dexie por shopCode para evitar race conditions
const dbInstancesCache = new Map();

const createIndexedDb = (shopCode) => {
  if (!shopCode) {
    console.warn("[IndexedDB] shopCode is required to create database instance");
    return;
  }

  // Retornar instancia cacheada si existe
  if (dbInstancesCache.has(shopCode)) {
    return dbInstancesCache.get(shopCode);
  }

  const dbName = `BistroWebDb_${shopCode}`;
  const db = new Dexie(dbName);

  db.version(1).stores({
    orders:
      "++id, uuid, origin, status, createdAt, comment, amount, netAmount, vatAmount, products, asyncStatus, paymentWay, lastUpdate, ticketNumber, movementType, discounts,timeStamp",
  });

  db.version(2).stores({
    cashboxes:
      "++id, amount, billNumber, cashAccumAmount, cashMovementId, comments, date, ticketNumber, movementType, totalAccumDiscountPerProductAmount,waiter,externalReference,customerId, saleAuthCode, saleCaptureWay, saleId, saleOrigin, salePaymentMethod, saleType, sequence, totalAccumAmount, totalDiscountAmount, totalTaxesAmount, totalVatAmount, userName, uuid",
  });

  db.version(3).stores({
    cashboxReports:
      "++id, sync, uuid, totalAmountOfCashboxMovements , createdAt, auditsMovements, closeDate, closeAmount, declaredAmount,lastCloseAmount, openAmount, openDate, total, totalCard,totalDeposit,totalOnline, totalOrders,totalQR, totalWithdrawal, fiscalData",
  });

  db.version(4).stores({
    cashboxReports:
      "++id, sync, uuid, totalSaleAmount, totalSales, totalVoidedNT, totalAmountVoidedNT, totalAmountOfCashboxMovements , createdAt, auditsMovements, closeDate, closeAmount, declaredAmount,lastCloseAmount, openAmount, openDate, total, totalCard,totalDeposit,totalOnline, totalOrders,totalQR, totalWithdrawal, fiscalData",
  }).upgrade((tx) => {
    return tx.table("cashboxReports").toCollection().modify((report) => {
      report.totalSaleAmount = report.totalSaleAmount || 0;  // Valor predeterminado
      report.totalSales = report.totalSales || 0;
      report.totalVoidedNT = report.totalVoidedNT || 0;
      report.totalAmountVoidedNT = report.totalAmountVoidedNT || 0;
    });
  });

  db.version(5).stores({
    tableNames: "++id, tableId, name, updatedAt",
  });

  db.version(6).stores({
    cashboxes:
      "++id, amount, billNumber, cashAccumAmount, cashMovementId, comments, date, ticketNumber, movementType, totalAccumDiscountPerProductAmount,waiter,externalReference,customerId, saleAuthCode, saleCaptureWay, saleId, saleOrigin, salePaymentMethod, saleType, sequence, totalAccumAmount, totalDiscountAmount, totalTaxesAmount, totalVatAmount, userName, uuid, isTableOrder, guestCount",
  }).upgrade((tx) => {
    return tx.table("cashboxes").toCollection().modify((cashbox) => {
      cashbox.isTableOrder = cashbox.isTableOrder || false;
      cashbox.guestCount = cashbox.guestCount || 0;
    });
  });

  db.version(7).stores({
    orders:
      "++id, uuid, origin, status, createdAt, comment, amount, netAmount, vatAmount, products, asyncStatus, paymentWay, lastUpdate, ticketNumber, movementType, discounts, timeStamp, tableId, tableName, isTableOrder, guestCount, isPaid, txClosed",
 }).upgrade((tx) => {
    return tx.table("orders").toCollection().modify((order) => {
      order.txClosed = order.txClosed || null;
    });
  });

  // Cachear la instancia para reutilización
  dbInstancesCache.set(shopCode, db);

  return db;
};

export default createIndexedDb;
